import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import useUserStore from "../components/UserStore";
import MyModal from "../components/MyModal";
import highchartsAccessibility from "highcharts/modules/accessibility";
import Button from "react-bootstrap/Button";
import { Row, Col } from "react-bootstrap";
import zones from "../utils/zones";
import { InfoCircleFill } from "react-bootstrap-icons";
highchartsAccessibility(Highcharts);

const SessionChartPower = (props) => {
    const { user, signedIn, setUser, setSignedIn } = useUserStore(
        (state) => state
    );
    const [session, setSession] = useState(false);
    const [loading, setLoading] = useState(false);
    const [chartOptions, setChartOptions] = useState({});
    const [firstDraw, setFirstDraw] = useState(true);
    const [ftpLineVisible, setFtpLineVisible] = useState(true);
    const [ftpZonesVisible, setFtpZonesVisible] = useState(false);
    const [mmpLineVisible, setMmpLineVisible] = useState(false);
    const [mmpZonesVisible, setMmpZonesVisible] = useState(false);

    const ftpColours = {
        0: '#99cdff',
        1: '#aedc92',
        2: '#cefece',
        3: '#feff99',
        4: '#ffcc00',
        5: '#ff9801',
        6: '#ff6600',
        7: '#ed1c24'
    };

    // useEffect to control when the logic is run, i.e. only on props change
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            updateOptions(props.workoutData);
            setLoading(false);
        };

        fetchData().catch("Fetching session data error: ", console.error);
    }, []);



    const updateOptions = (workoutData = null) => {

        let series = [];

        let chartTheme = {
            light: {
                background: "#ffffff",
                color: "rgba(33,33,33,1)",
                seriesColors: ["#3f93f4", "#ed1c24", "#ffa505"],
                gridColor: "#E6E6E6",
            },
        };

        // work out the tickInterval
        let tickInterval = 300;
        let durationTotal = 0;
        Object.keys(workoutData.chartData).forEach(function (key) {
            for (let i = 0; i < workoutData.chartData[key].length; i++) {
                durationTotal += parseInt(workoutData.chartData[key]);
            }
        });
        durationTotal = durationTotal / 100;

        if (durationTotal < 600) {
            tickInterval = 30;
        } else if (durationTotal < 1800) {
            tickInterval = 150;
        } else if (durationTotal < 3600) {
            tickInterval = 600;
        } else {
            tickInterval = 1200;
        }

        // if we have workout data build the chart series
        if (workoutData) {
            series.push({
                type: "area",
                color: ftpColours[0],
                showInLegend: false,
                data: workoutData.zonedChartData[1],
            });
            series.push({
                type: "area",
                color: ftpColours[1],
                showInLegend: false,
                data: workoutData.zonedChartData[2],
            });
            series.push({
                type: "area",
                color: ftpColours[2],
                showInLegend: false,
                data: workoutData.zonedChartData[3],
            });
            series.push({
                type: "area",
                color: ftpColours[3],
                showInLegend: false,
                data: workoutData.zonedChartData[4],
            });
            series.push({
                type: "area",
                color: ftpColours[4],
                showInLegend: false,
                data: workoutData.zonedChartData[5],
            });
            series.push({
                type: "area",
                color: ftpColours[5],
                showInLegend: false,
                data: workoutData.zonedChartData[6],
            });
        }

        // build the chart options
        let chartOptions = {
            chart: {
                type: "area",
                // backgroundColor: chartTheme["light"].background,
                zoomType: "x",
                animation: false,
                height: 250,
                marginRight: 0,
                resetZoomButton: {
                    theme: { style: { display: "none" } },
                },

            },
            credits: {
                enabled: false,
            },
            title: {
                text: null,
            },
            series: series,
            plotOptions: {
                series: {
                    animation: false,
                    connectNulls: false,
                },
                line: {
                    lineWidth: 1,
                },
                area: {
                    lineWidth: 0,
                    fillOpacity: 1,
                },
                // spline: {
                //   dataGrouping: {
                //     enabled: true,
                //     forced: true,
                //     smoothed: true,
                //     units: [["second", [1]]],
                //   },
                //   lineWidth: 1,
                // },
            },
            yAxis: [
                {
                    title: {
                        text: '% FTP'
                    }
                }

            ],
            xAxis: {
                tickInterval: tickInterval,
                endOnTick: false,
                title: {
                    text: 'Time (Min)'
                },
                labels: {
                    formatter: function () {
                        let minutes = Math.floor(this.value / 60);
                        let seconds = this.value - minutes * 60;
                        return minutes + ':' + seconds;
                        // return window['Highcharts'].dateFormat('%M:%S', this.value);
                    }
                },
                plotLines: [],

            },
        };

        setChartOptions(chartOptions);
    };

    // Styles for non-highcharts components
    let styles = {
        buttonCol: {
            display: "flex",
            justifyContent: "right",
        },
        button: {},
    };

    // return
    return loading ? (
        <div>Loading main chart...</div>
    ) : (
        <>
            <Row>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={chartOptions}
                />
            </Row>
        </>
    );
};

export default SessionChartPower;
